var map = {
	"./avatar": 8,
	"./avatar.svg": 8,
	"./circle-facebook": 9,
	"./circle-facebook.svg": 9,
	"./circle-twitter": 10,
	"./circle-twitter.svg": 10,
	"./default": 11,
	"./default.svg": 11,
	"./facebook": 12,
	"./facebook.svg": 12,
	"./footer-arrow": 13,
	"./footer-arrow-sm": 14,
	"./footer-arrow-sm.svg": 14,
	"./footer-arrow.svg": 13,
	"./hambergermenu": 15,
	"./hambergermenu.svg": 15,
	"./hamburger-menu": 16,
	"./hamburger-menu.svg": 16,
	"./header-arrow-black": 17,
	"./header-arrow-black.svg": 17,
	"./header-arrow-sm-black": 18,
	"./header-arrow-sm-black.svg": 18,
	"./instagram": 19,
	"./instagram-black": 20,
	"./instagram-black.svg": 20,
	"./instagram.svg": 19,
	"./link": 21,
	"./link.svg": 21,
	"./linkedin": 22,
	"./linkedin.svg": 22,
	"./logo-black-background": 23,
	"./logo-black-background.svg": 23,
	"./logo-white-background": 24,
	"./logo-white-background.svg": 24,
	"./logo_dark": 25,
	"./logo_dark.svg": 25,
	"./logo_white": 26,
	"./logo_white.svg": 26,
	"./share": 27,
	"./share.svg": 27,
	"./telegram-4": 28,
	"./telegram-4.svg": 28,
	"./tiktok-1": 29,
	"./tiktok-1.svg": 29,
	"./tiktok-black": 30,
	"./tiktok-black.svg": 30,
	"./twitter": 31,
	"./twitter.svg": 31,
	"./typo_logo": 32,
	"./typo_logo.png": 32,
	"./video-play-btn": 33,
	"./video-play-btn.svg": 33,
	"./x-circle": 34,
	"./x-circle.svg": 34,
	"./youtube": 35,
	"./youtube-black": 36,
	"./youtube-black.svg": 36,
	"./youtube.svg": 35
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 53;